import Sprite from "./Sprite";
import { TILES } from "../../helpers/tiles";
import styles from "./CharacterBody.module.css";

export default function CharacterBody({
  bodyFrameCoord,
  bodySpriteSize = 32,
  bodyOffsetLeft = -8,
  bodyOffsetTop = -19,
  hasShadow = true,
  hop = false,
  movingPixelsRemaining,
}) {
  const getTop = () => {
    if (hop && movingPixelsRemaining > 0) {
      return bodyOffsetTop - 2;
    }

    return bodyOffsetTop;
  };

  return (
    <div className={styles.characterBody}>
      {hasShadow && <Sprite frameCoord={TILES.SHADOW} />}
      <div
        // Styles the enemy relative to shadow
        className={styles.characterSpriteContainer}
        style={{
          left: bodyOffsetLeft,
          top: getTop(),
        }}
      >
        <Sprite frameCoord={bodyFrameCoord} size={bodySpriteSize} />
      </div>
    </div>
  );
}
